import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWizzairComponent } from './simple-icons-wizzair.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWizzairComponent ],
    exports:      [ SimpleIconsWizzairComponent ],
    bootstrap:    []
})
export class SimpleIconsWizzairModule {}
